import t from './common/localization'
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogBox from './DialogBox';
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "25px",
    height: "25px",
    filter: "brightness(0) invert(1)",
  },
  loader: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
  button: {
      border: 0,
      borderRadius: 18,
      boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
      height: "30px",
      width: "40px",
      color: "red",
      margin: "3px",
      // padding: '0 20px',
    },
}));

const RemoveDialog = ({ open, message, endpoint, itemId, onResult }) => {
  const classes = useStyles();

  const handleRemove = async () => {
    const response = await fetch(`/api/${endpoint}/${itemId}`, { method: 'DELETE' });
    if (response.ok) {
      onResult(true, "Deleted Successfully!");
    } else {
      onResult(false, "Error while deletion!");
    }
  };

    const onConfirm= ()=> {
      handleRemove();
    }

    const onCancel= ()=> {
      onResult(false);
    }

  return (
   <DialogBox
              sweetAlertProps = {
                {
                warning: true,
                  title:t('sharedRemoveConfirm'),
                  show:open,// must have prop
                  onConfirm: onConfirm,
                  onCancel: onCancel,// must have prop
                  // custom:true,
                  showCancel: true,
                  showCloseButton: false,
                  confirmBtnText:t('sharedRemove'),
                  cancelBtnText:t('sharedCancel'),
                  focusCancelBtn: true,
                  confirmBtnStyle:{fontSize:"16px", color: 'white', borderRadius: '10px', backgroundColor: '#22B410',
                   boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)', width: "100px", textAlign: 'center',
                   verticalAlign: 'center',textDecoration: '', padding: '6px 0'},
                  cancelBtnStyle :{fontSize:"16px", color: 'red'}
                }
              }
            >
              {message}
              {/* Children custom html here */}
            </DialogBox>

  );
};

export default RemoveDialog;
